import React, { useEffect, useState } from "react";
import { HiOutlineKey } from "react-icons/hi";
import { Link } from "react-router-dom";
import { getAllEvents } from "app/_services/ehs/ehsEventServices";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { ACTIVE_MODULE } from "app/_constants/constant";

const ScheduleEvent = ({
  match: {
    params: { siteId },
  },
}) => {
  const [events, setEvents] = useState([]);
  const [eventsToShow, setEventsToShow] = useState([]);
  const [filter, setFilter] = useState({
    type: "All",
  });

  const onChangeFilter = ({ target: { name, type, checked, value } }) =>
    setFilter((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));

  useEffect(() => {
    setEventsToShow(
      events.filter((event) => filter.type === "All" || event.category === filter.type)
    );
  }, [filter.type, events]);

  useEffect(() => {
    getAllEvents("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setEvents(response.data);
    });
  }, []);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          { name: "OHSE Review", path: "/health-safety-and-environment/audits-meetings" },
          { name: "Schedule Event" },
        ]}
        module={ACTIVE_MODULE.ohse}
      />
      <div className="card p-3">
        <div className="simple-card-title">
          <h3 className="mt-2 ml-3">Select Meeting Type</h3>
          {/* <div className="d-flex pl-4 pt-1 ml-3 mt-1">
                        <div className="pr-3">
                            <label className="radio radio-primary form-check-inline mr-3">
                                <input type="radio" name={"type"} value="All" onChange={onChangeFilter} checked={filter.type === "All"} />
                                <span>All ({events.length})</span>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="pr-3">
                            <label className="radio radio-primary form-check-inline mr-3">
                                <input type="radio" name={"type"} value="Internal Audit" onChange={onChangeFilter} checked={filter.type === "Internal Audit"} />
                                <span>Internal Audits ({events.filter((s) => s.category === "Internal Audit").length})</span>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="pr-3">
                            <label className="radio radio-primary form-check-inline mr-3">
                                <input type="radio" name={"type"} value="External Audit" onChange={onChangeFilter} checked={filter.type === "External Audit"} />
                                <span>External Audits ({events.filter((s) => s.category === "External Audit").length})</span>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                        <div className="pr-3">
                            <label className="radio radio-primary form-check-inline mr-3">
                                <input type="radio" name={"type"} value="Meeting" onChange={onChangeFilter} checked={filter.type === "Meeting"} />
                                <span>Meetings ({events.filter((s) => s.category === "Meeting").length})</span>
                                <span className="checkmark"></span>
                            </label>
                        </div>
                    </div> */}
          <BackBtn
            url={
              (siteId ? `/sites/${siteId}` : "") +
              "/health-safety-and-environment/audits-meetings"
            }
          />
        </div>
        <div className="permitCardsList">
          <ul>
            {eventsToShow.map((event) => (
              <li key={event.id}>
                <Link
                  to={
                    (siteId ? `/sites/${siteId}` : "") +
                    "/health-safety-and-environment/audits-meetings/scheduled-event/add/" +
                    event.id
                  }
                  className="btn"
                >
                  <span className="permitIcons">
                    <HiOutlineKey />
                  </span>
                  <span>{event.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ScheduleEvent;
